import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import _ from 'lodash';

const DisplayCurrencyMessage = ({ roomPrices, className, isConfirmation }) => {
  const distinctHotels = _.uniqBy(roomPrices, 'hotelName');

  let roomPricesToConsider = _.filter(roomPrices, (r) => r.currencyCode
    && r.propertyCurrencyCode && r.currencyCode !== r.propertyCurrencyCode);

  if (roomPricesToConsider.length === 0) {
    return null;
  }

  if (_.uniqBy(roomPricesToConsider, (r) => r.currencyCode).length === 1) {
    roomPricesToConsider = _.take(roomPricesToConsider, 1);
  }

  return (
    <div className={clsx('text-xs', className)}>
      <b>Note:</b>
      {_.map(roomPricesToConsider, (roomPrice) => (
        <Fragment
          key={roomPrice.hotelName + roomPrice.currencyCode + roomPrice.propertyCurrencyCode}
        >
          {' '}
          Prices
          {roomPrice.hotelName && distinctHotels.length > 1 ? ` for Hotel (${roomPrice.hotelName})` : ''}
          {' '}
          are quoted in
          {' '}
          <b>{roomPrice.currencyCode}</b>
          , based on the current exchange rate.
          {' '}
          {isConfirmation ? 'The reservation will be charged in the hotel\'s currency.' : 'The rate will be booked in local currency.'}
          {' '}
          Your card issuer may charge you a conversion fee.
        </Fragment>
      ))}
    </div>
  );
};

DisplayCurrencyMessage.propTypes = {
  roomPrices: PropTypes.arrayOf(PropTypes.shape({
    hotelName: PropTypes.string,
    currencyCode: PropTypes.string,
    propertyCurrencyCode: PropTypes.string,
  })).isRequired,
  className: PropTypes.string,
  isConfirmation: PropTypes.bool,
};

DisplayCurrencyMessage.defaultProps = {
  className: '',
  isConfirmation: false,
};

export default DisplayCurrencyMessage;
